// src/helpers/appLinks.js
// Single source of truth for the published app store URLs.
// Keep this in sync with the live listings; everything that links to the apps
// (about page, footer, "Open in app" banner) should import from here.

export const APP_STORE_URL =
  "https://apps.apple.com/kr/app/korehalal-trip-muslim-travel/id6736513932";

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.korehalal.app";

// Custom URL scheme used for deep-linking into the native app.
//
// The two app flavors register different schemes so they don't fight over the
// same links, so this site must fire the one matching its own environment —
// dev.korehalal.com (and localhost) reach the dev build, the live domain the
// store build. Derived from the host rather than an env var so it can't drift
// from the site actually serving the page.
// Keep in sync with lib/_env/enviroment_type.dart in korehalal_app.
const PROD_HOSTS = ["korehalal.com", "www.korehalal.com"];

export const APP_SCHEME =
  typeof window !== "undefined" && !PROD_HOSTS.includes(window.location.hostname)
    ? "korehalaldev"
    : "korehalal";
